import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { GetService, PostService } from "../../../../Services/ConstantService";
import { API_URL } from "../../../../Services/ApiService";
import {
  showErrorAlert,
  showSuccessAlert,
} from "../../../../Helper/SweetAlert";
import { MoonLoader } from "react-spinners";

export default function Paymentcredentails() {
  const [Apikey, setApikey] = useState("");
  const [Apisecret, setApisecret] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [submitLoader, setsubmitLoader] = useState(false);


  function submit() {
    if (!Apikey || !Apisecret ) {
      setError(true);
      return;
    }
    const data = { api_key:Apikey, api_secret:Apisecret, id:1 };

    setsubmitLoader(true);
    PostService(API_URL.UPDATE_PAYMENT_CREDENTIALS, data).then(
      (res) => {
        if (res.data.status === true) {
          setsubmitLoader(false)
          getPaymentDetails()
          showSuccessAlert(res?.data?.message, getPaymentDetails);
        } else {
          showErrorAlert(res.data?.message);
        }
      },
      (err) => {
        showErrorAlert(err.data?.message);
      }
    );
  }

  useEffect(() => {
    getPaymentDetails();
  }, []);

  const getPaymentDetails = async () => {
    // setLoading(true)
    PostService(API_URL.GET_PAYMENT_CREDENTIALS).then((res) => {
      if (res.data?.status === true) {
        setApikey(res.data?.data?.api_key);
        setApisecret(res.data?.data?.api_secret);
        setLoading(false);
      } else {
        showErrorAlert(res.data?.message);
        setLoading(false);
      }
    });
  };

  return (
    <div>
      <section className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h3>Payment Credentials</h3>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <Link
                  to="/panel/dashboard"
                  className="breadcrumb-item"
                  style={{ textDecoration: "none" }}
                >
                  Dashboard
                </Link>
                <Link className="breadcrumb-item active">Payment Credentials</Link>
              </ol>
            </div>
          </div>
        </div>
      </section>
      <div class="card">
        {!loading && (
          <div class="card-body mt-3">
            <h4 class="card-title offset-md-1">Braintree Information</h4>
            <div className="row offset-md-1">
              <div className="col-md-5 col-12 form-group">
                <label>	API KEY</label>
                <input
                  type="text"
                  placeholder="API KEY"
                  className="form-control"
                  value={Apikey}
                  onChange={(e) => setApikey(e?.target?.value)}
                />
                 {error && !Apikey && (
                        <div className="error mt-1">Api key is required</div>
                      )}
              </div>
              <div className="col-md-5 col-12 form-group">
                <label>API SECRET</label>
                <input
                  type="text"
                  placeholder="API SECRET"
                  className="form-control"
                  value={Apisecret}
                  onChange={(e) => setApisecret(e?.target?.value)}
                />
                 {error && !Apisecret && (
                        <div className="error mt-1">Api Secret is required</div>
                      )}
              </div>
            </div>
            <div>
              <div className="offset-md-1">
                <button
                  className="btn btn-primary ml-3"
                  onClick={() => submit()}
                >
                   {submitLoader ? (
                    <i className="fas fa-spinner fa-spin"></i>
                  ) : (
                    "Submit"
                  )}
                 
                </button>
              </div>
            </div>
          </div>
        )}
        {loading ? (
          <div className="LoaderSpinner">
             <MoonLoader
                          color={"#003bff"}
                          loading={loading}
                          speedMultiplier={0.6}
                          size={50}
                        />
            <div>Loading... Please wait.</div>
          </div>
        ) : (
          ""
        )}
      </div>
    </div>
  );
}
